(function () {
  let cartTotalCents = null;

  function computePercent(thresholdCents) {
    if (!thresholdCents || cartTotalCents === null) return 0;

    let percent = (cartTotalCents / thresholdCents) * 100;
    if (percent > 100) percent = 100;
    if (percent < 4 && cartTotalCents > 0) percent = 4;
    if (percent < 0) percent = 0;

    return percent;
  }

  function applyToBar(barEl) {
    if (!barEl) return;

    const thresholdCents = parseInt(barEl.dataset.thresholdCents, 10);
    const progressEl = barEl.querySelector('[data-free-shipping-progress]');
    if (!progressEl) return;

    progressEl.style.width = `${computePercent(thresholdCents)}%`;
  }

  function updateAllBars() {
    document.querySelectorAll('[data-free-shipping-bar]').forEach(applyToBar);
  }

  function fetchInitialCartTotal() {
    if (!window.routes || !window.routes.cart_url) return;

    fetch(`${window.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        cartTotalCents = cart.total_price;
        updateAllBars();
      })
      .catch((error) => console.error(error));
  }

  document.addEventListener('DOMContentLoaded', () => {
    fetchInitialCartTotal();

    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      const observer = new MutationObserver(() => updateAllBars());
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cartData = event && event.cartData;
      if (cartData && typeof cartData.total_price !== 'undefined') {
        cartTotalCents = cartData.total_price;
        updateAllBars();
      } else {
        fetchInitialCartTotal();
      }
    });
  });
})();
